import { useCallback } from 'react';

import { useMutation } from '@apollo/client';

import { UPDATE_PRODUCT, CREATE_PRODUCT } from 'gql/catalogs';

import translateUpdatedPack from '../edit/lib/translateUpdatedPack';
import FORM_TYPES from '../lib/formTypes';
import translateNewPack from '../new/lib/translateNewPack';

const ACTION_MESSAGE = {
  [FORM_TYPES.new]: 'creado',
  [FORM_TYPES.edit]: 'actualizado',
};

function useSubmit({
  setDialogContent,
  setVisibleDialog,
  formType = FORM_TYPES.edit,
}) {
  const mutation =
    FORM_TYPES.new === formType ? CREATE_PRODUCT : UPDATE_PRODUCT;
  const dataKey = mutation.definitions[0].name.value;
  const translatePack =
    FORM_TYPES.new === formType ? translateNewPack : translateUpdatedPack;
  const [fetchMutation, { loading, error, reset }] = useMutation(mutation, {
    onCompleted: (data) => {
      const {
        [dataKey]: { sku, name },
      } = data;
      setDialogContent(
        `El pack ${name} con sku ${sku} se ha ${ACTION_MESSAGE[formType]} exitosamente`,
      );
      reset();
      setVisibleDialog(true);
    },
  });
  const onSubmit = useCallback((updatedFields) => {
    const product = translatePack(updatedFields);
    fetchMutation({
      variables: {
        input: product,
      },
    });
  }, []);
  return { loading, error, onSubmit };
}
export default useSubmit;
